import {
  GET_STATES_REQUEST,
  GET_STATES_SUCCESS,
  GET_STATES_ERROR,
} from '~gatsby-theme-autonomy/redux/actions/types'

export const getStatesRequest = () => {
  return {
    type: GET_STATES_REQUEST,
  }
}

export const getStatesSuccess = () => {
  return {
    type: GET_STATES_SUCCESS,
  }
}

export const getStatesError = (error) => {
  return {
    type: GET_STATES_ERROR,
    error: true,
    payload: error,
  }
}

export const getStates =
  (iso) =>
  async (dispatch, getState, { api }) => {
    try {
      dispatch(getStatesRequest())

      const states = await api.getStates(iso)
      dispatch(getStatesSuccess())

      return states
    } catch (error) {
      dispatch(getStatesError(error))
      throw error
    }
  }
